module.exports = __webpack_public_path__ + "static/media/landing2.644eb120.svg";